<template>
  <card-seplag titulo="Formulários Prefeitura de Cuiabá" cor="#00acc1">
    <div class="p-col-12 cardBuscaFormulario">
      <div class="p-col-12 p-md-2">
        <Button
          label="Relatório"
          class="p-button-success"
          @click="exportExcel()"
        />
      </div>
      <div class="p-col-12 p-md-6">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 2px;
          "
          class="p-button-info"
        >
          <ToggleButton
            v-model="filtroProtocoloBoolean"
            onLabel="Com protocolo"
            offLabel="Sem protocolo"
            onIcon="pi pi-check"
            offIcon="pi pi-times"
            style="width: 30%"
          />
          <InputText
            v-model="parametrosConsulta.textoPesquisa"
            placeholder="Digite o nome do usuário ou CPF sem os pontos"
            style="width: 65%"
          />
          <Button
            icon="pi pi-search"
            class="p-button-info"
            @click="carregarDados()"
            style="width: 5%"
          />
        </div>
      </div>
    </div>
    <div class="p-col-12">
      <table-seplag
        :dados.sync="dadosFormularios"
        :hasExibirCabecalho="false"
        :campos="colunasTabelaFormulario"
        :paginacao="true"
        :onSearchPaginacao="paginacaoFiltro"
        :loading="true"
        :totalRegistro.sync="totalRegistro"
        :urlPanagicao="urlPanagicao"
        :firstRecordIndex.sync="first"
      >
        <Column headerStyle="width: 9em;">
          <template #body="linha">
            <Button
              label="Editar"
              v-tooltip="'Editar'"
              icon="pi pi-pencil"
              :class="
                linha.data.numrProtocolo != null &&
                linha.data.numrProtocolo != ''
                  ? 'p-button-rounded p-button-success'
                  : 'p-button-rounded p-button-warning'
              "
              @click="editarLinha(linha.data)"
            />
          </template>
        </Column>
      </table-seplag>
    </div>

    <ExibirPDF
      v-if="pdfBase64"
      v-model="exibirPDFDocumento"
      :tamanhoTela="'70.vw'"
      :alturaTela="'50.vw'"
      :tituloTela="nomeModalPDF"
      :pdfElement="pdfBase64"
    />
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import ExibirPDF from "@/template/CardExibirPDF.vue";
import download from "downloadjs";

import { baseApiUrl } from "@/config/global";

export default {
  name: "FORMPREFEITURA_MENU",
  components: { CardSeplag, TableSeplag, ExibirPDF },
  data: function () {
    return {
      namePagina: "Consulta Formulário Prefeitura Cba",
      dadosFormularios: [],
      colunasTabelaFormulario: [
        { nome: "cpfFormatado", titulo: "CPF", tamanho: "9.vw" },
        { nome: "nomePessoa", titulo: "Nome" },
        { nome: "descCargo", titulo: "Cargo" },
        { nome: "numrProtocolo", titulo: "Protocolo" },
      ],
      loadingPaginacao: true,
      totalRegistro: 0,
      urlPanagicao: `prefeituracba`,
      filtroProtocoloBoolean: true,
      parametrosConsulta: {
        protocolo: "S",
        textoPesquisa: null,
      },
      size: 10,
      page: 0,
      first: 0,
      exibirPDFDocumento: null,
      pdfBase64: "",
      nomeModalPDF: "MODAL PDF",
    };
  },
  methods: {
    carregarDados() {
      this.paginacaoFiltro(this.size, this.page);
    },

    paginacaoFiltro(size, page, firstAux = null) {
      this.size = size;
      this.page = page;

      if (firstAux != null) this.first = firstAux;

      if (this.parametrosConsulta == null) {
        this.parametrosConsulta= "todos";
      }

      this.parametrosConsulta.protocolo = this.filtroProtocoloBoolean == true ? "S" : "N";

      this.$http.post(`${baseApiUrl}/${this.urlPanagicao}/pesquisa?size=${this.size}&page=${this.page}`, 
          JSON.stringify(this.parametrosConsulta)
          )        
        .then((res) => {
          this.dadosFormularios = res.data.content;
          this.totalRegistro = res.data.totalElements;
          this.setFiltro();
        });
      if (this.parametrosConsulta == "todos") {
        this.parametrosConsulta = null;
      }
    },
    editarLinha(linha) {
      
      this.$router.push({
        name: "FORMPREFEITURA_FORMULARIO",
        params: { idenPrefeituraCba: linha.idenPrefeituraCba },
      });
    },

    exportExcel() {
      this.$http
        .post(`${baseApiUrl}/relatorios/saudeprefcuiaba`)
        .then((res) => {
          download(
            `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`,
            `${res.data.nomeArquivo}`,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
        });
    },

    setFiltro() {
      let filtro = {
        namePagina: `${this.namePagina}`,
        campos: [
          { key: "protocolo", value: this.filtroProtocoloBoolean },
          { key: "campoPesquisa", value: this.parametrosConsulta.textoPesquisa },
          { key: "size", value: this.size },
          { key: "page", value: this.page },
          { key: "first", value: this.first },
        ],
      };
      this.$store.commit("setFiltros", filtro);
    },

    getFiltro() {
      let filtros = this.$store.getters.getFiltros;

      let filtro = filtros.filter(
        (filtro) => filtro.namePagina === this.namePagina
      );
      if (filtro.length > 0) {
        let protocolo = filtro[0].campos.find(
          (element) => element.key === "protocolo"
        );
        this.filtroProtocoloBoolean = protocolo ? protocolo.value : null;

        let campoPesquisa = filtro[0].campos.find(
          (element) => element.key === "campoPesquisa"
        );
        this.parametrosConsulta.textoPesquisa = campoPesquisa ? campoPesquisa.value : null;

        let size = filtro[0].campos.find((element) => element.key === "size");
        this.size = size ? size.value : null;

        let page = filtro[0].campos.find((element) => element.key === "page");
        this.page = page ? page.value : null;

        let firstFiltro = filtro[0].campos.find(
          (element) => element.key === "first"
        );
        this.first = firstFiltro ? firstFiltro.value : 0;

        return this.parametrosConsulta.textoPesquisa ? true : false;
      }

      return false;
    },
  },
  mounted() {
    this.getFiltro();
    this.carregarDados();
  },
};
</script>

<style>
.cardBuscaFormulario {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>